import React from "react";
import Cleave from 'cleave.js/react';
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

export default function FormularioDevolucionVte({
    show,
    onClose,
    cuponVTE,
    autorizacionVTE,
    terminal,
    tarjeta,
    cuotas,
    onChange,
    onSubmit
}) {
    return (
        <Modal show={show} onHide={onClose} size="lg" backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Datos VTE para devolución</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form-horizontal form-material">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="cuponVTE">Cupón</label>
                            <input
                                id="cuponVTE"
                                type="text"
                                className="form-control"
                                name="cuponVTE"
                                value={cuponVTE}
                                onChange={onChange}
                                placeholder="123456"
                                autoComplete="off"
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label htmlFor="autorizacionVTE">Autorización</label>
                            <input
                                id="autorizacionVTE"
                                type="text"
                                className="form-control"
                                name="autorizacionVTE"
                                value={autorizacionVTE}
                                onChange={onChange}
                                placeholder="789123"
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="terminal">Terminal</label>
                            <Cleave
                                id="terminal"
                                className="form-control"
                                name="terminal"
                                value={terminal}
                                onChange={onChange}
                                options={{ blocks: [4], numericOnly: true }}
                                placeholder="0001"
                                autoComplete="off"
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label htmlFor="cuotas">Cuotas</label>
                            <input
                                id="cuotas"
                                type="text"
                                className="form-control"
                                name="cuotas"
                                value={cuotas}
                                onChange={onChange}
                                placeholder="3"
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="tarjeta">Tarjeta</label>
                            <input
                                id="tarjeta"
                                type="text"
                                className="form-control"
                                name="tarjeta"
                                value={tarjeta}
                                onChange={onChange}
                                placeholder="VISA"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <button className="btn btn-sm btn-grey" onClick={onClose}>
                    Cancelar
                </button>
                <button className="btn btn-sm background-rojo-megatone" onClick={onSubmit}>
                    Enviar
                </button>
            </Modal.Footer>
        </Modal>
    );
}
FormularioDevolucionVte.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    cuponVTE: PropTypes.string,
    autorizacionVTE: PropTypes.string,
    cuotas: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    tarjeta: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    terminal: PropTypes.string
}